import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tableSelect", "columnSelect", "keyColumnSelect", "nameInput", "typeInput"]

  connect() {
    const schemaEl = document.getElementById("schema-data")
    if (schemaEl) {
      this.schema = JSON.parse(schemaEl.dataset.schema)
    }
  }

  tableChanged(event) {
    const tableId = event.target.value
    this.updateColumns(tableId)
  }

  updateColumns(tableName) {
    if (!this.schema) return

    const tableData = this.schema[tableName]
    const columns = tableData ? tableData.columns : []
    const defaultKey = tableData ? tableData.default_key : 'laz_id'

    this.columnSelectTarget.innerHTML = '<option value="">Select Column</option>'
    columns.forEach(col => {
      const option = document.createElement("option")
      option.value = col.bq_name
      option.dataset.type = col.data_type
      option.text = col.name
      this.columnSelectTarget.appendChild(option)
    })

    if (this.hasKeyColumnSelectTarget) {
      this.keyColumnSelectTarget.innerHTML = `<option value="">Default (${defaultKey})</option>`
      columns.forEach(col => {
        const option = document.createElement("option")
        option.value = col.bq_name
        option.text = col.name
        this.keyColumnSelectTarget.appendChild(option)
      })
    }
  }

  columnChanged(event) {
    const selectedOption = this.columnSelectTarget.selectedOptions[0]
    if (selectedOption) {
      const type = selectedOption.dataset.type
      const name = selectedOption.value

      if (this.hasNameInputTarget) {
        this.nameInputTarget.value = name
      }
      if (this.hasTypeInputTarget) {
        this.typeInputTarget.value = type
      }
    }
  }
}
